'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import { Text } from '@/shared/ui'
import { shareList } from './constants'
import style from './share.module.scss'

interface ShareProps extends HTMLProps<HTMLDivElement> {}

export const Share = ({ className, ...restProps }: ShareProps) => {
  const translate = useTranslations()

  return (
    <div className={clsx(style.container, className)} {...restProps}>
      <Text type="d" color="dark-040">
        {translate('titleShare')}
      </Text>
      <div className={style.buttonContainer}>
        {shareList.map(({ url, name }) => {
          return (
            <button
              className={clsx(style.shareButton, 'text text_type_t2 text_color_dark')}
              key={name}
              onClick={() => {
                if (typeof window !== 'undefined') {
                  const shareHref = url + location.href

                  window.open(shareHref, '_blank')
                }
              }}
            >
              {name}
            </button>
          )
        })}
      </div>
    </div>
  )
}
